// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__E1CjQ","container":"style_container__MwpgK","frame":"style_frame__Q+icr","content":"style_content__zSUBa"};